import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import jwt_decode from 'jwt-decode';
import {BehaviorSubject, Observable} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = environment.apiUrl + 'auth'; // Replace with your Quarkus backend URL
  private userRoleSubject = new BehaviorSubject<string[] | null>(null);
  public userRole$: Observable<string[] | null> = this.userRoleSubject.asObservable();

  constructor(private http: HttpClient, private router: Router, private _snackBar: MatSnackBar) {}

  loginWithCode(code: string) {
    // Send the code to the Quarkus backend for authentication
    this.http.post(`${this.apiUrl}/loginWithCode`, { code }).subscribe({
      next: (response: any) => {
        // Assuming the backend returns a JWT token upon successful authentication
        const token = response.token;
        if (token) {
          // Save the token in localStorage or sessionStorage
          localStorage.setItem('jwt_token', token);
          this.router.navigate(['/tablenumber']).then(r => {}); // Navigate to the /order route
          const userRoles = this.getUserRole();
          this.userRoleSubject.next(userRoles);
        }
      },
      error: (error) => {
        console.error('Login failed', error);
        this._snackBar.open('Falscher Login-Code', 'Schließen', {duration: 3000});
      }
    });
  }

  getUserRole(): string[] | [] {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      // Decode the JWT token to get the payload
      const decodedToken: any = jwt_decode(token);
      // Assuming that the role is stored in the 'groups' claim
      return decodedToken.groups;
    }
    return [];
  }

  getUserName(): string {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      // Decode the JWT token to get the payload
      const decodedToken: any = jwt_decode(token);
      // Assuming that the role is stored in the 'groups' claim
      return decodedToken['name'];
    }
    return '';
  }

  getUserGuid(): string {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      // Decode the JWT token to get the payload
      const decodedToken: any = jwt_decode(token);
      // Assuming that the role is stored in the 'groups' claim
      return decodedToken['guid'];
    }
    return '';
  }

  getWaiterShiftGuid(): string {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      // Decode the JWT token to get the payload
      const decodedToken: any = jwt_decode(token);
      // Assuming that the role is stored in the 'groups' claim
      return decodedToken['shiftGuid'];
    }
    return '';
  }

  getTenantName(): string {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      // Decode the JWT token to get the payload
      const decodedToken: any = jwt_decode(token);
      // Assuming that the role is stored in the 'groups' claim
      return decodedToken['tenantName'];
    }
    return '';
  }

  logout() {
    // Remove the JWT token from localStorage or sessionStorage
    localStorage.removeItem('jwt_token');
    this.router.navigate(['/login']).then(r => {});
  }

  isLoggedIn(): boolean {
    // Check if the JWT token exists in localStorage or sessionStorage
    return !!localStorage.getItem('jwt_token');
  }
}
